import { render, staticRenderFns } from "./TomadaPreco.vue?vue&type=template&id=4d24911a&scoped=true"
import script from "./TomadaPreco.vue?vue&type=script&lang=js"
export * from "./TomadaPreco.vue?vue&type=script&lang=js"
import style0 from "./TomadaPreco.vue?vue&type=style&index=0&id=4d24911a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24911a",
  null
  
)

export default component.exports